export default __webpack_public_path__ + "static/media/rainbow.4490d185.jpg";